export const logout = {
  name: "logout" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M2.1 3a.9.9 0 0 1 .9-.9h9.5a.9.9 0 1 1 0 1.8H3.9v16.2h8.6a.9.9 0 1 1 0 1.8H3a.9.9 0 0 1-.9-.9V3Zm13.264 3.364a.9.9 0 0 1 1.272 0l5 5a.9.9 0 0 1 0 1.272l-5 5a.9.9 0 0 1-1.272-1.272l3.463-3.464H8a.9.9 0 0 1 0-1.8h10.827l-3.463-3.464a.9.9 0 0 1 0-1.272Z" clip-rule="evenodd"/></svg>`,
  keywords: ["logout"],
  category: "action" as const,
};
